import { render, staticRenderFns } from "./evection.vue?vue&type=template&id=95c4abfc&scoped=true"
import script from "./evection.vue?vue&type=script&lang=js"
export * from "./evection.vue?vue&type=script&lang=js"
import style0 from "./evection.vue?vue&type=style&index=0&id=95c4abfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c4abfc",
  null
  
)

export default component.exports